<template>
  <v-card min-width="20vw" align="center" justify="center" light outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <p>{{ $t('message') }}<br><b>{{ brokerAccount.identifier }}</b> - <b>{{ brokerAccount.broker.name }}</b>?</p>
      <div class="d-flex align-center justify-center my-7">
        <v-icon class="mr-3" large>fa-exclamation-circle</v-icon>
        <h4 v-html="$t('alert')"/>
      </div>
      <v-btn @click="verifyAccount">{{ $t('btnVerify') }} <v-icon class="ml-3" color="blue" small>fa-check-circle</v-icon></v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/brokerAccount';
export default {
name: "VerifyBrokerAccount",
    props: {
        brokerAccount: Object,
    },
    methods: {
        verifyAccount() {
            if(this.brokerAccount.automated) {
                Repository.verifyBrokerAccount(this.brokerAccount.id).then((response) => {
                    if(response.status < 400 && response) {
                        this.brokerAccount.verified = true;
                        this.closeWindow();
                    }
                });
            }
        },
        closeWindow() {
          this.$emit('closeWindow');
        }
    }
}
</script>

<i18n>
{
  "en": {
    "title": "Verify Broker Account",
    "message": "Are you sure you want to verify the account:",
    "alert": "By verifying, you cannot add trades manually<br>and cannot import historic trades to this account.",
    "btnVerify": "Yes, verify it!"
  },
  "es": {
    "title": "Verifica Cuenta de Broker",
    "message": "¿Estas seguro que quieres verificar la cuenta",
    "alert": "Verificando, no podrás agregar trades manualmente<br>ni podrás importar trades históricos a esta cuenta.",
    "btnVerify": "Sí, ¡verificar!"
  }
}
</i18n>

<style scoped>

</style>
